// extracted by mini-css-extract-plugin
export default {"loaderpage":"pageloader_loaderpage__FKxoR"};